import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Button } from '../../../Controls/Button';
import Icons from '../../../Elements/Icons';
import { ListItem } from '../styled';
export const CreatableListItem = memo(function CreatableListItem({ item, formatOptionLabel, disabled, isEditMode, dataTestId, onRemove, }) {
    const handleClick = useCallbackRef((e) => {
        e.preventDefault();
        e.stopPropagation();
        onRemove(item.value);
    });
    return (_jsxs(ListItem, { "data-testid": dataTestId && `${dataTestId}-item-${encodeURIComponent(item.value)}`, children: [_jsx("span", { children: formatOptionLabel?.(item) ?? item.label }), isEditMode && (_jsx(Button, { ghost: true, disabled: disabled, "data-testid": dataTestId && `${dataTestId}-remove-${encodeURIComponent(item.value)}`, onClick: handleClick, children: _jsx(Icons.Remove, {}) }))] }));
});
